import {gql} from '@apollo/client'

export const PROCEDURE_STATUS_SUMMARY = gql`
  query procedureStatusSummary {
    client {
      id
      procedureStatusSummary {
        status
        count
      }
    }
  }
`

export interface ProcedureStatusSummaryQueryVariables {
  isLimitedAdmin: boolean
}

export interface ProcedureStatusSummaryQueryResult {
  client: {
    id: string
    procedureStatusSummary: ProcedureStatusSummary[]
  }
}

export interface ProcedureStatusSummary {
  status: string
  count: number
}
